import {CameraOutlined, CloseCircleOutlined, DownloadOutlined, UpSquareOutlined} from '@ant-design/icons';
import React, {Component} from 'react';
import {connect} from "react-redux";
import {sagaMiddleware} from "../../helper/store";
import cookie from "react-cookies";
import {Redirect} from 'react-router-dom';
import {getDeviceStatus, watchPollStatus} from "../../redux_actions/device_status.action";
import {updateEditorState, updateLoaderState} from '../../redux_actions/c240_loader.action';
import {
    C240PromptType,
    C240SlideStatus,
    c240TaskType,
    cassetteType,
    HTSState,
    queueActions,
    queueColorMap
} from "../../utils/const";
import "./c240_control_panel_view.css";
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CloseIcon from '@mui/icons-material/Close';
import {
    Badge,
    Button,
    Card,
    Col,
    Divider,
    List,
    message,
    Modal,
    Radio,
    Row,
    Spin,
    Tag,
    Tooltip,
    Typography
} from 'antd';
import GatePrompt from "../../component/scanner/scanWorkflow/c240_gate_prompt.js";
import C240Header from "./c240_header";
import {checkSystemState, systemStateNotificationHandler} from "../../utils/scanner_utils";
import {closeDrawer, openDrawer} from "../../redux_actions/dashboard.action";
import ReloadConfigPromptWrapper from '../../component/scanner/reload_config_prompt_wrapper';
import {stopScannerServer} from "../../utils/device_utils"
import {
    getC240Status,
    getScannerState,
    updateQueueState,
    watchC240DeviceStatus,
    watchC240ScannerStateUpdate,
    watchPersistedStateStatus
} from "../../redux_actions/c240_device_status.action";
import C240CassetteView from "./C240CassetteView";
import {notNull} from "../../utils/utils";
import {get_response} from "../../helper/request";
import {updateQueueUIUtility} from "./utils";
import { Button as MuiButton } from '@mui/material';
import {SkipNext} from "@mui/icons-material";

const { Text } = Typography;

// shows a high level info view of each tray in rack
// with info whether preview/scan taken or in queue
// and whether barcode taken
// has two modes based on whether use is super user or not
class RackView extends Component {
    constructor(props) {
        super(props);
    }

    getRackColor = (status,isBarcodeTaken) => {
        if (status === 'INSIDE_RACK') {
            if(isBarcodeTaken){
                return '#66CC66';
            } else {
                return "#F6BE00";
            }
        } else if (status === 'ON_FEEDER') {
            return 'pink';
        } else if (status === "ON_STAGE") {
            return "#00CCFF";
        }
        return "#B0B0B0";
    }

    getRackDiffColor = (status) => {
        if (status === 'NO_CHANGE') {
            return 'grey';
        } else if (status === 'INSERTED') {
            return '#013220';
        } else if (status === "REMOVED") {
            return "red";
        } else if (status === "REPLACED") {
            return "yellow";
        }
        return "grey";
    }

    toolTipInfo = (i,j,racks) => {
        return(
            <div>
            <Row style={{ display: "flex", flexDirection:"column"}}>
                <Col style={{ textAlign:"center"}}> <b>{"Status for Slot " + (i === 0 ? "R" : "L") + (j+1)}</b> </Col>
                <Divider></Divider>
            </Row>
            <Row>
                <Col>
                    {/* <Badge color= {this.getRackColor(racks[i][j].cassette_state._name_)}/> */}
                    {(racks[i][j].cassette_state._name_).replaceAll('_'," ") === "EMPTY" ? "Slot is Empty" : "Slides are " + (racks[i][j].cassette_state._name_).replaceAll('_'," ")}
                </Col>
                {(racks[i][j].cassette_state._name_).replaceAll('_'," ") === "EMPTY" ? null : 
                <Col>
                    {/* <CassetteBarcodeState barcodeTaken={racks[i][j].barcode_taken}></CassetteBarcodeState> */}
                    {racks[i][j].barcode_taken ? "Label photos captured" : "Label photos not captured"}
                    <Divider></Divider>
                </Col>
                }
            </Row>
            </div>
        )
    }

    render() {
        let racks_table = [];
        
        let racks = this.props.racks;

        for (let i = racks.length-1; i >= 0; i--) {
            let toolTipPosition = i === 0 ? "right" : "left";
            if (this.props.is_superuser) {
                let thisrack = [];
                for (let j = racks[i].length - 1; j >= 0; j--) {
                    let myCassetteType = (((racks[i][j] || {}).cassette_type || {})._name_ || cassetteType.SIX_1_BY_3_SLIDES);
                    let slots = [];
                    if (myCassetteType === cassetteType.TWO_2_BY_3_SLIDES){
                        slots = [0, 1, 2];
                    }else{
                        slots = [0, 1, 2, 3, 4, 5];
                    }
                    const key = `R${i}T${j}`;
                        thisrack.push(
                            <Row key={key}>
                                <Card 
                                    className="less-padded-ant-card-body"
                                    bodyStyle={{ padding: "4px !important" }}
                                    onClick={(e) => {e.stopPropagation(); this.props.onSelectCassette(key)}}
                                    bordered={true}
                                    style={this.props.selectedCassette === key ? {
                                            backgroundColor: this.getRackColor(racks[i][j].cassette_state._name_,racks[i][j].barcode_taken),
                                            border: "solid yellow",
                                            padding: "2px !important",
                                            marginTop:"2px",
                                            lineHeight: "19px"
                                        } : {
                                            backgroundColor: this.getRackColor(racks[i][j].cassette_state._name_,racks[i][j].barcode_taken),
                                            border: "solid black",
                                            borderWidth: "0.01px",
                                            padding: "2px !important",
                                            marginTop:"2px",
                                            lineHeight: "19px"
                                        }}>
                                    <Row style={{ display: "flex",alignItems: "center"}}>                                
                                    <Col span={12} style={{fontSize:'0.5vw',paddingLeft:'0.2vw'}} >
                                    {j + " : " + racks[i][j].cassette_state._name_.replaceAll("_", " ")}
                                    </Col>
                                    <Col span={1.5}>
                                        <CassetteBarcodeState barcodeTaken={racks[i][j].barcode_taken}></CassetteBarcodeState>
                                    </Col>
                                    
                                    <Col span={5}>
                                        {this.props.is_superuser ? 
                                        <Button size="small" style={{ fontSize: "11px", height: "17px"}} loading={this.props.loadings["take_thumbnails"]} onClick={() => {
                                                this.props.enterLoading("take_thumbnails");
                                                this.props.call("take_thumbnails", "?rack=" + i + "&tray=" + j);
                                            }} ghost>
                                                <CameraOutlined />
                                        </Button> : null}
                                    </Col>
                                    <Col >
                                        {this.props.is_superuser ? 
                                        <Button size="small" style={{ fontSize: "11px", height: "17px"}} loading={this.props.loadings["rack_to_stage"]} onClick={() => {
                                                this.props.enterLoading("rack_to_stage");
                                                this.props.call("rack_to_stage", "?rack=" + i + "&tray=" + j);
                                            }} ghost>
                                                <DownloadOutlined />
                                        </Button> : null}
                                    </Col>
                                    </Row>
                                    <Row style={{ display: "flex", alignItems: "center", paddingLeft:'0.2vw'}}>
                                    
                                    <Tooltip 
                                        placement={toolTipPosition} 
                                        title={
                                            <div>
                                                {slots.map((value) => {
                                                    return <Row key={value.toString()} style={{ display: "flex"}}>
                                                        <Col>Slot {value+1}</Col>
                                                        <Col style={{ marginLeft:"10px"}}>
                                                            <InSlideState currentSlideState={(this.props.slideLevelScanPreviewStatus[key + "S" + value]||{}).slideState}></InSlideState>
                                                        </Col>                                            
                                                        <Col>
                                                            {((this.props.slideLevelScanPreviewStatus[key + "S" + value]||{}).slideState||"INITIAL").replaceAll('_'," ")}
                                                        </Col>
                                                    </Row>})
                                                }
                                            </div>} 
                                        color="#2db7f5" >
                                        <div style={{ display: "flex"}}>
                                            {slots.map((value) => {
                                                return <Col key={value.toString()}>
                                                    <InSlideState currentSlideState={(this.props.slideLevelScanPreviewStatus[key + "S" + value]||{}).slideState}></InSlideState>
                                                </Col>})}
                                        </div>
                                    </Tooltip>
                                    
                                    <Col align="Right">
                                        <Tag style={{fontSize:'0.5vw',marginRight: "0px",marginTop: "0px",padding: "1px 1px",lineHeight: "10px"}} color={this.getRackDiffColor(racks[i][j].diff_cassette_state._name_)}>
                                            {racks[i][j].diff_cassette_state._name_}</Tag>
                                    </Col >
                                    </Row>
                                </Card>
                            </Row>
                        );
                }
                racks_table.push(
                <Col key={`rack-${i === 0 ? "R" : "L"}`} offset={0} style={{marginLeft: "4px"}} span={11} >
                    <span style={{ fontSize: "12px" }}>Rack {i === 0 ? "R" : "L"}</span>
                    {thisrack}
                </Col>);
            } else {
                let thisrack = [];
                for (let j = racks[i].length - 1; j >= 0; j--) {                    
                    let myCassetteType = (((racks[i][j] || {}).cassette_type || {})._name_ || cassetteType.SIX_1_BY_3_SLIDES);
                    let slots = [];
                    if (myCassetteType === cassetteType.TWO_2_BY_3_SLIDES){
                        slots = [0, 1, 2];
                    }else{
                        slots = [0, 1, 2, 3, 4, 5];
                    }
                    const key = `R${i}T${j}`;
                    thisrack.push(                                             
                        <Row key={key}>
                            <Tooltip placement={toolTipPosition} title={
                                    <div>
                                        {this.toolTipInfo(i,j,racks)}
                                        {(racks[i][j].cassette_state._name_).replaceAll('_'," ") === "EMPTY" ? null : 
                                        slots.map((value) => {
                                            return (<Row key={value.toString()} style={{ display: "flex"}}>
                                                <Col>Slide {value+1}</Col>
                                                <Col style={{ marginLeft:"10px"}}><InSlideState currentSlideState={(this.props.slideLevelScanPreviewStatus[key + "S" + value]||{}).slideState}></InSlideState></Col>                                            
                                                <Col>{((this.props.slideLevelScanPreviewStatus[key + "S" + value]||{}).slideState||"INITIAL").replaceAll('_'," ") === C240SlideStatus.INITIAL 
                                                        ? "Awaiting Action" : ((this.props.slideLevelScanPreviewStatus[key + "S" + value]||{}).slideState||"INITIAL").replaceAll('_'," ") }</Col>
                                            </Row>)})
                                        }
                                        
                                    </div>} color="#2db7f5" >
                            <Card 
                                className="less-padded-ant-card-body"
                                bodyStyle={{ padding: "4px !important" }}
                                onClick={(e)=>{e.stopPropagation(); this.props.onSelectCassette(key)}}
                                bordered={true}
                                style={
                                    this.props.selectedCassette === key ? {
                                        // backgroundColor: this.getRackColor(racks[i][j].cassette_state._name_),
                                    border: `solid ${this.getRackColor(racks[i][j].cassette_state._name_,racks[i][j].barcode_taken)}`,
                                    borderWidth: "3 px",
                                    padding: "2px !important",
                                    marginTop:"7px",
                                    lineHeight: "2.8vh"
                                    }:{
                                        // backgroundColor: this.getRackColor(racks[i][j].cassette_state._name_),
                                    borderLeft: `solid ${this.getRackColor(racks[i][j].cassette_state._name_,racks[i][j].barcode_taken)}`,
                                    borderRight: `solid rgba(0,0,0,0)`,
                                    borderTop: `solid rgba(0,0,0,0)`,
                                    borderBottom: `solid rgba(0,0,0,0)`,
                                    borderWidth: "3 px",
                                    padding: "50px !important",
                                    marginTop:"7px",
                                    lineHeight: "2.8vh"
                                    }
                                }>
                                {/* <Row style={{ display: "flex"}}> */}
                                <Row>
                                    {/* <div > */}
                                        <Col span={5} style={{fontSize:'0.8vw',paddingLeft:'0.4vw'}} >
                                        {/* for user view only  */}
                                        {i === 0 ? "R" : "L"}{j+1}
                                        </Col>
                                        {/* <Col span={2}>
                                            {(racks[i][j].cassette_state._name_).replaceAll('_'," ") === "EMPTY" ? null : 
                                            <CassetteBarcodeState barcodeTaken={racks[i][j].barcode_taken}></CassetteBarcodeState>
                                            }
                                        </Col> */}
                                    {/* </div> */}
                                    <Col span={19} style={{display:"flex", flexDirection:"row", justifyContent: "space-between", paddingRight: "15px"}}>
                                        {(racks[i][j].cassette_state._name_).replaceAll('_'," ") === "EMPTY" ? null : 
                                        slots.map((value) => {return <Col key={value.toString()}>
                                        <InSlideState currentSlideState={(this.props.slideLevelScanPreviewStatus[key + "S" + value]||{}).slideState}></InSlideState>
                                        </Col>})
                                        }
                                    </Col>
                                
                                </Row>
                            </Card>
                            </Tooltip>
                        </Row>
                    );
                }
                racks_table.push(
                <Col key={`rack-${i === 0 ? "R" : "L"}`} offset={0} style={{marginRight: "20px"}} span={11} >
                    {/* <span style={{ fontSize: "12px" }}>Rack {i === 0 ? "R" : "L"}</span> */}
                    {thisrack}
                </Col>);
            }
        }
        return racks_table;
    }
}

// task queue for what is ongoing and what is next in the queue
class ScanPreviewQueueView extends Component {
    constructor(props) {
        super(props);
    }

    queueTitle = (taskType) => {
        if (taskType === c240TaskType.TAKE_SLIDE_PREVIEW) {
            return " Preview";
        } else if(taskType === c240TaskType.TAKE_AUTO_SCAN) {
            return " Auto Scan";
        } else if(taskType === c240TaskType.TAKE_PREVIEW_FOR_CALIBRATION) {
            return " Scan Calibration";
        } else if(taskType === c240TaskType.TAKE_SCAN_OF_SELECTED_REGION) {
            return " Scan";
        } else if(taskType === c240TaskType.OPEN_GATE) {
            return "Open Gate";
        } else if(taskType === c240TaskType.TAKE_BARCODE) {
            return " Barcode"
        } else if(taskType === c240TaskType.PUT_CASSETTE_IN_RACK) {
            return " Put Back"
        } else if(taskType === c240TaskType.DIRECT_SCAN) {
            return " Direct Scan"
        } else {
            return taskType.replaceAll("_"," ")
        }
    }


    wasBarcodeReadTried = (taskType) => {
        if (taskType === C240SlideStatus.PREVIEW_DONE || 
            taskType === C240SlideStatus.SCAN_IN_QUEUE || 
            taskType === C240SlideStatus.AUTO_SCAN_IN_QUEUE || 
            taskType === C240SlideStatus.SCAN_ONGOING || 
            taskType === C240SlideStatus.SCAN_DONE || 
            taskType === C240SlideStatus.SCAN_CRASHED || 
            taskType === C240SlideStatus.SCAN_STITCHING ) {
            return true;
        } else {
            return false;
        }
    }

    toCamelCase = (str) => {
        return str
          .toLowerCase()
          .split(' ')
          .map((word, index) => 
            index === 0 
              ? word.charAt(0).toUpperCase() + word.slice(1)
              : word.charAt(0).toUpperCase() + word.slice(1)
          )
          .join(' ');
    }

    getQueueItems = (currQueueState) => {
        let queue_items = [];
        const queue_elems = currQueueState['queue'];
        const search = this.props.searchText.toLowerCase();
        let non_queued_elems = { ...this.props.slideLevelScanPreviewStatus };
        for (const slideKey in non_queued_elems) {
            const barcodeThumbnail = non_queued_elems[slideKey]?.previewResponse?.barcodeThumbnail || "";
            if (non_queued_elems[slideKey].slideState === 'INITIAL' && barcodeThumbnail === "") {
                delete non_queued_elems[slideKey];
            }
        }
        if (currQueueState['ongoing'] === null  && currQueueState['queue'].length === 0) {
            queue_items.push(
            // <Card key={"q-empty"} className="centered less-padded-ant-card-body" bordered={true} style={{width:'260px'}} key={"EMPTY"}>
                <div className="centered">
                <Row style={{fontSize:'16px', marginLeft:'2px'}}> {"No tasks scheduled"} </Row>
                </div>
            // </Card>
            );
        }
        let ongoing;
        if (currQueueState['ongoing'] !== null) {
            const {rack, tray, slide} = currQueueState['ongoing'];
            const ongoingSlideKey = `R${rack}T${tray}S${slide}`;
            const ongoingScanPreviewStatus = this.props.slideLevelScanPreviewStatus[ongoingSlideKey];
            const ongoingPreviewStatus = ongoingScanPreviewStatus?.previewResponse;
            const ongoingBarcodeStatus = ongoingPreviewStatus?.barcodeReadSuccess;
            const ongoingBarcodeThumbnail = ongoingPreviewStatus?.barcodeThumbnail || "";
            const slideState = ongoingScanPreviewStatus?.slideState;
            const taskType = currQueueState['ongoing']['taskType'] || "";
            const ongoingSlideName = ongoingBarcodeStatus ? ongoingPreviewStatus.slideName.trim() : ongoingBarcodeThumbnail !== "" ? ongoingBarcodeThumbnail.trim() :
                                            this.wasBarcodeReadTried(slideState) ? " barcode-read-failed": "";
            const barcodeColor = ongoingBarcodeStatus ? '#dddbdb' : this.wasBarcodeReadTried(slideState) ? '#f0d1d1': '#F5F5DC';
            if (ongoingSlideName.toLowerCase().includes(search)) {
                if (ongoingScanPreviewStatus) {
                    delete non_queued_elems[ongoingSlideKey];
                }
                let key = `R${rack}T${tray}`
                let rowStyle = {fontSize:'16px', height:'35px', marginLeft:'2px', display: "flex", alignItems: "center"};
                const enabledSkipPreviewCalibration = taskType === c240TaskType.TAKE_PREVIEW_FOR_CALIBRATION && this.props.waitingForUserToCalibratePreview;
                ongoing = (
                <Row  key={"on-going"} style={enabledSkipPreviewCalibration ? {animation: "shadow-pulse-focus 0.8s infinite", backgroundColor: 'rgb(0 0 255 / 50%)'}: {}}>
                    {/* <    placement="left" title={`${this.queueTitle(taskType)}Slot ${rack === 0 ? "R" : "L"}${tray+1}, Slide ${slide+1}`}> */}
                        {/* <Card className="less-padded-ant-card-body" bordered={true} style={{border: `solid #18A558`,width:'253px', cursor:'pointer'}} key={`R${rack === 0 ? "R" : "L"}T${tray}S${slide}`}
                            onClick={(e)=>{e.stopPropagation();this.props.onSelectCassette(key)}}> */}
                            <Row align ="right" style={rowStyle} onClick={(e)=>{e.stopPropagation();this.props.onSelectCassette(key)}}>
                                <Col span={18} style={{paddingLeft:"20px", display: "flex", alignItems: "center"}}>
                                    <Col span={4} >
                                        {`${rack === 0 ? "R" : "L"}${tray+1}-S${slide+1}`}
                                    </Col>
                                    <Col span={15}>
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            height: '32px',
                                        }}>
                                            <input
                                                type="text"
                                                readOnly
                                                value={ongoingSlideName}
                                                className="slide-name-input"
                                                title={ongoingSlideName}
                                                style={{
                                                width: "100%",
                                                height: "32px",
                                                boxSizing: "border-box",
                                                border: `1.5px dotted #000`,
                                                padding: "0 6px",
                                                fontSize: "14px",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                outline: "none",
                                                textAlign: 'left',
                                                lineHeight: '32px',
                                                backgroundColor: barcodeColor,
                                                borderRadius: '8px',
                                                }}
                                            />
                                        </div>
                                    </Col>
                                    <Col span={8} style={{paddingLeft:"5px", paddingRight:"10px"}}>
                                        {`${this.queueTitle(taskType)}`}
                                    </Col>
                                </Col>
                                <Col span={6} className={"full-height"} style={{paddingTop:'5px', paddingBottom:'5px', paddingRight:'7px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                                    <Col span={5} style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                    {enabledSkipPreviewCalibration?
                                        <Tooltip placement="top" title={"Skip Scan Calibration"}>
                                            <MuiButton
                                                variant="outlined"
                                                color={"secondary"}
                                                size="small"
                                                sx={{height: "20px",
                                                    width: "20px",
                                                    minWidth: "0",
                                                    padding: '0',
                                                    borderColor: "#000"
                                                }}
                                                onClick={(e)=>{this.skipPreviewCalibration(e, rack, tray, slide, taskType)}}>
                                                <SkipNext
                                                    style={{
                                                        color: "#000",
                                                        height: "20px",
                                                        width: "20px",
                                                        minWidth: "0",
                                                        padding: '0'
                                                    }}
                                                />
                                            </MuiButton>
                                        </Tooltip> : null}
                                    </Col>
                                </Col>
                            <br></br>
                            </Row>
                        {/* </Card> */}
                    {/* </Tooltip> */}
                </Row>);
            }
        }
        queue_items.push(ongoing);
        const disablePriortiseForFirstTask = (queue_elems['0'] || {})['taskType'] === c240TaskType.OPEN_GATE
        for (const elem of queue_elems) {
            const {rack, tray, slide} = elem;
            const taskType = elem['taskType'] || "";
            let key = `R${rack}T${tray}`
            let slideKey = `R${rack}T${tray}S${slide}`;
            let isAnimated = false;
            let colorCode = elem['queueColorMap'];
            const scanPreviewStatus = this.props.slideLevelScanPreviewStatus[slideKey]
            if (scanPreviewStatus) {
                delete non_queued_elems[slideKey];
            }
            const previewStatus = scanPreviewStatus?.previewResponse;
            const barcodeStatus = previewStatus?.barcodeReadSuccess;
            const barcodeThumbnail = previewStatus?.barcodeThumbnail || "";
            const slideState = scanPreviewStatus?.slideState;
            const slideName = barcodeStatus ? previewStatus.slideName.trim() : barcodeThumbnail !== "" ? barcodeThumbnail.trim() :
                        this.wasBarcodeReadTried(slideState) ? " barcode-read-failed": "";
            const barcodeColor = barcodeStatus ? '#dddbdb' : this.wasBarcodeReadTried(slideState) ? '#f0d1d1': '#F5F5DC';

            if (search && !slideName.toLowerCase().includes(search)) {
                continue;
            }
            if ((slideName === "" || slideName === " barcode-read-failed") && search !== "") {
                continue;
            }
            if(notNull(colorCode)){
                isAnimated = true;
            }

            // Define styling for animation
            let rowStyle = {fontSize:'16px', height:'35px'};
            if (isAnimated) {
                if (colorCode === queueColorMap.PRIORITISE){
                    rowStyle = {fontSize:'16px', height:'35px', backgroundColor: "rgba(210,210,210,0.3)", 
                                borderRadius: "0px"}
                } else if(colorCode === queueColorMap.REMOVE){
                    rowStyle = {fontSize:'16px', height:'35px', backgroundColor: "rgba(250,80,80,0.3)", 
                                    borderRadius: "0px"}
                } else if (colorCode === queueColorMap.ADD) {
                    rowStyle = {fontSize:'16px', backgroundColor: "rgba(60, 240, 156,0.3)",
                                borderRadius: "0px"}
                }
            }

            const enabledPrioritise = !this.props.remove_queue_interaction && (elem !== queue_elems['0']) && !(elem === queue_elems['1'] && disablePriortiseForFirstTask) &&
                                        (isAnimated !== true || colorCode === queueColorMap.ADD);
            const enabledDeprioritise = !this.props.remove_queue_interaction && taskType !== c240TaskType.OPEN_GATE && elem!==queue_elems[(queue_elems.length-1).toString()] && (isAnimated !== true || colorCode === queueColorMap.ADD);
            queue_items.push(
            <Row key={`q-item-${key}S${slide}-${taskType}`} id={(isAnimated && colorCode !== queueColorMap.PRIORITISE) ? 'highlight' : null }>
                {/* <Tooltip placement="left" title={`${this.queueTitle(taskType)}Slot ${rack === 0 ? "R" : "L"}${tray+1}, Slide ${slide+1}`}> */}
                    {/* <Card className="less-padded-ant-card-body" bordered={true} 
                        style={{ width:'253px', cursor:'pointer', margin:"1px auto"}} key={`R${rack === 0 ? "R" : "L"}T${tray}S${slide}`}
                        onClick={(e)=>{e.stopPropagation();this.props.onSelectCassette(key)}}> */}
                        <Divider></Divider>
                        <Row align ="right" style={rowStyle} onClick={(e)=>{e.stopPropagation();this.props.onSelectCassette(key, slide)}}>
                            <Col span={18} className={"full-height"} style={{paddingLeft:"20px", display: "flex", alignItems: "center"}}>
                                <Col span={4}>
                                    {(isAnimated !== true || colorCode === queueColorMap.ADD) ? `${rack === 0 ? "R" : "L"}${tray+1}-S${slide+1}`: null}                                    
                                </Col>
                                <Col span={15}>
                                    {(isAnimated !== true || colorCode === queueColorMap.ADD) ? (
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: '32px',
                                    }}>
                                        <input
                                            type="text"
                                            readOnly
                                            value={slideName}
                                            title={slideName}
                                            className="slide-name-input"
                                            style={{
                                            width: "100%",
                                            height: "32px",
                                            boxSizing: "border-box",
                                            border: `1.5px dotted #000`,
                                            padding: "0 6px",
                                            fontSize: "14px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            outline: "none",
                                            textAlign: 'left',
                                            lineHeight: '32px',
                                            backgroundColor: barcodeColor,
                                            borderRadius: '8px',
                                            }}
                                        />
                                    </div>
                                    ) : null}
                                </Col>
                                <Col span={8} style={{paddingLeft:"5px", paddingRight:"10px"}}>
                                    {(isAnimated !== true || colorCode === queueColorMap.ADD) ? `${this.queueTitle(taskType)}`: null}
                                </Col>
                            </Col>
                            <Col span={6} className={"full-height"} style={{paddingTop:'5px', paddingBottom:'5px', paddingRight:'7px', justifyContent: 'flex-end', display: 'flex', alignItems: 'center'}}>
                                
                                <Col span={5} style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                {enabledPrioritise?
                                    <Tooltip placement="top" title={"Prioritise Task"}>
                                        <MuiButton
                                            variant="outlined"
                                            color={"secondary"}
                                            size="small"
                                            sx={{height: "20px",
                                            width: "20px",
                                            minWidth: "0",
                                            padding: '0',
                                            borderColor: "#000"
                                        }}
                                            onClick={(e)=>{this.prioritiseTaskCaller(e, rack, tray, slide, taskType)}}>
                                            <KeyboardDoubleArrowUpIcon
                                                style={{
                                                    color: "#000",
                                                    height: "20px",
                                                    width: "20px",
                                                    minWidth: "0",
                                                    padding: '0'
                                                }}
                                            />
                                        </MuiButton>
                                    </Tooltip> : null}
                                </Col>
                                <Col span={5} style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                {enabledDeprioritise ?
                                    <Tooltip placement="topRight" overlayStyle={{width: "130px"}} title={"De-Prioritise Task"}>
                                        <MuiButton
                                            variant="outlined"
                                            color="secondary"
                                            size="small"
                                            sx={{height: "20px",
                                            width: "20px",
                                            minWidth: "0",
                                            padding: '0',
                                            borderColor: "#000"
                                        }}
                                            onClick={(e)=>{this.dePrioritiseTaskCaller(e, rack, tray, slide, taskType)}}>
                                            <KeyboardArrowDownIcon
                                                style={{
                                                    color: "#000",
                                                    height: "20px",
                                                    width: "20px",
                                                    minWidth: "0",
                                                    padding: '0'
                                                }}
                                            />
                                        </MuiButton>
                                    </Tooltip> : null}
                                </Col>
                                <Col span={5} style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                <Tooltip placement="topLeft" title={"Cancel Task"}>
                                    <MuiButton
                                                variant="outlined"
                                                color="secondary"
                                                size="small"
                                                sx={{height: "20px",
                                                width: "20px",
                                                minWidth: "0",
                                                padding: '0',
                                                borderColor: "#000"
                                            }}
                                                onClick={(e)=>{this.removeTaskCaller(e, rack, tray, slide, taskType)}}
                                                disabled={this.props.remove_queue_interaction}>
                                                <CloseIcon
                                                    style={{
                                                        color: "#000",
                                                        height: "20px",
                                                        width: "20px",
                                                        minWidth: "0",
                                                        padding: '0'
                                                    }}
                                                />
                                    </MuiButton>
                                </Tooltip>
                                </Col>
                        </Col>
                            {/*:null}*/}
                        </Row>
                    {/* </Card> */}
                {/* </Tooltip> */}
            </Row>);
        }
        queue_items.push(<Divider orientation="center" style={{paddingTop: '10px'}}>Non-Queued Slides</Divider>)
        const non_queued_elems_sorted = Object.fromEntries(
            Object.entries(non_queued_elems).sort((a, b) =>
                a[0].localeCompare(b[0], undefined, {numeric: true})
            )
        )
        for (const slideKey in non_queued_elems_sorted) {
            if (!Object.prototype.hasOwnProperty.call(non_queued_elems_sorted, slideKey)) continue;
            const elem = non_queued_elems_sorted[slideKey];
            const {rack, tray, slide} = elem.cassetteSlide;
            const taskType = this.toCamelCase(elem.slideState || "");
            let key = `R${rack}T${tray}`;
            const previewStatus = elem.previewResponse;
            const barcodeStatus = previewStatus?.barcodeReadSuccess;
            const barcodeThumbnail = previewStatus?.barcodeThumbnail || "";
            const slideName = barcodeStatus ? previewStatus.slideName.trim() : barcodeThumbnail !== "" ? barcodeThumbnail.trim() :
                        this.wasBarcodeReadTried(elem?.slideState) ? " barcode-read-failed": "";
            const barcodeColor = barcodeStatus ? '#dddbdb' : this.wasBarcodeReadTried(elem?.slideState) ? '#f0d1d1': '#F5F5DC';
            if (search && !slideName.toLowerCase().includes(search)) {
                continue;
            }
            if ((slideName === "" || slideName === " barcode-read-failed") && search !== "") {
                continue;
            }
            // Define styling for animation
            let rowStyle = {fontSize:'16px', height:'35px'};
            queue_items.push(
            <Row key={`q-item-${key}S${slide}-non-queued`} id='non-queued'>
                {/* <Tooltip placement="left" title={`${this.queueTitle(taskType)}Slot ${rack === 0 ? "R" : "L"}${tray+1}, Slide ${slide+1}`}> */}
                    {/* <Card className="less-padded-ant-card-body" bordered={true}
                        style={{ width:'253px', cursor:'pointer', margin:"1px auto"}} key={`R${rack === 0 ? "R" : "L"}T${tray}S${slide}`}
                        onClick={(e)=>{e.stopPropagation();this.props.onSelectCassette(key)}}> */}
                        <Divider></Divider>
                        <Row align ="right" style={rowStyle} onClick={(e)=>{e.stopPropagation();this.props.onSelectCassette(key, slide)}}>
                            <Col span={18} className={"full-height"} style={{paddingLeft:"20px", display: "flex", alignItems: "center"}}>
                                <Col span={4} style={{color: '#37990e' }}>
                                    {`${rack === 0 ? "R" : "L"}${tray+1}-S${slide+1}`}
                                </Col>
                                <Col span={15}>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: '32px',
                                    }}>
                                        <input
                                            type="text"
                                            readOnly
                                            value={slideName}
                                            title={slideName}
                                            className="slide-name-input"
                                            style={{
                                            width: "100%",
                                            height: "32px",
                                            boxSizing: "border-box",
                                            border: `1.5px dotted #000`,
                                            padding: "0 6px",
                                            fontSize: "14px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            outline: "none",
                                            textAlign: 'left',
                                            lineHeight: '32px',
                                            borderRadius: '8px',
                                            backgroundColor: barcodeColor,
                                            }}
                                        />
                                    </div>
                                </Col>
                                <Col span={10} style={{paddingLeft:"5px"}}>
                                    {`${this.queueTitle(taskType)}`}
                                </Col>
                            </Col>
                        </Row>
                    {/* </Card> */}
                {/* </Tooltip> */}
                </Row>
            );
        }

        return queue_items;
    }

    prioritiseTaskCaller = (e, rack, tray, slide, taskType) => {
        //Update locally here first
        this.props.propsDispatch(updateQueueUIUtility(rack, tray, slide, taskType, queueActions.PRIORITISE, null, this.props.queue_state, this.props.disableQueueInteraction));
        this.props.alterTaskOrder(e, rack, tray, slide, taskType, null, "prioritise_task");
    }

    dePrioritiseTaskCaller = (e, rack, tray, slide, taskType) => {
        //Update locally here first
        this.props.propsDispatch(updateQueueUIUtility(rack, tray, slide, taskType, queueActions.DEPRIORITISE, null, this.props.queue_state, this.props.disableQueueInteraction));
        this.props.alterTaskOrder(e, rack, tray, slide, taskType, null, "de_prioritise_task");
    }

    removeTaskCaller = (e, rack, tray, slide, taskType) => {
        //Update locally here first
        this.props.propsDispatch(updateQueueUIUtility(rack, tray, slide, taskType, queueActions.REMOVE, null, this.props.queue_state, this.props.disableQueueInteraction));
        this.props.alterTaskOrder(e, rack, tray, slide, taskType, null, "remove_task");
    }

    skipPreviewCalibration = (e, rack, tray, slide, taskType) => {
        //Update locally here first
        this.props.propsDispatch(updateQueueUIUtility(rack, tray, slide, taskType, queueActions.REMOVE_PREVIEW_CALIBRATION, null, this.props.queue_state, this.props.disableQueueInteraction));
        this.props.alterTaskOrder(e, rack, tray, slide, taskType, null, "resume_queue_after_calibration");
    }

    render() {
        return this.getQueueItems(this.props.queue_state);
    }     
}

class CassetteBarcodeState extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let cassette_barcode_state = [];
        if (this.props.barcodeTaken === true) {
            cassette_barcode_state.push(<Badge key={"0"} status="success" style={{fontSize:"150%"}}/>);
        } else {
            cassette_barcode_state.push(<Badge key={"1"} status="default"/>);
        }
        return cassette_barcode_state;
    }
}


class InSlideState extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let in_slide_state = [];
        if (this.props.currentSlideState === "PREVIEW_ONGOING") {
            in_slide_state.push(<Badge status="processing" className="custom-large-badge" key={"0"} color="blue" />);
        } else if (this.props.currentSlideState === "PREVIEW_DONE") {
            in_slide_state.push(<Badge className="custom-large-badge" key={"1"} color="grey" />);
        } else if (this.props.currentSlideState === "PREVIEW_IN_QUEUE") {
            in_slide_state.push(<Badge className="custom-large-badge" key={"2"} color="blue" />);
        } else if (this.props.currentSlideState === "SCAN_IN_QUEUE") {
            in_slide_state.push(<Badge className="custom-large-badge" key={"2"} color="#CEFA05" />);
        } else if (this.props.currentSlideState === "SCAN_ONGOING" || this.props.currentSlideState === "SCAN_STITCHING" ) {
            in_slide_state.push(<Badge status="processing" className="custom-large-badge" key={"2"} color="#CEFA05" />);
        } else if (this.props.currentSlideState === "AUTO_SCAN_IN_QUEUE") {
            in_slide_state.push(<Badge className="custom-large-badge" key={"2"} color="blue" />);
        } else if (this.props.currentSlideState === "SCAN_DONE") {
            // "#3ECD32"
            in_slide_state.push(<Badge className="custom-large-badge" key={"3"} color="#3ECD32" />);
        } else if (this.props.currentSlideState === "SCAN_CRASHED") {
            in_slide_state.push(<Badge className="custom-large-badge" key={"4"} color="red" />);
        } else {
            in_slide_state.push(<Badge className="custom-large-badge" key={"5"} color="#D2DFF3" />);
        }
        return in_slide_state;
    }
}

const getDebugButtonList = (loadings, enterLoadingFn, callFn) => {
    let buttons = [];
    buttons.push(<Button type="primary" loading={loadings["health~connection"]} onClick={() => {
        enterLoadingFn("health~connection");
        callFn("health~connection");
    }}>
        Board Connected ?
    </Button>);
    
    buttons.push(<Button type="primary" loading={loadings["health~start"]} onClick={() => {
        enterLoadingFn("health~start");
        callFn("health~start");
    }}>
        Start Server
    </Button>);
    
    buttons.push(<Button type="primary" loading={loadings["health~stop"]} onClick={() => {
        enterLoadingFn("health~stop");
        callFn("health~stop");
    }}>
        Stop Server
    </Button>);
    
    buttons.push(<Button type="primary" loading={loadings["init"]} onClick={() => {
        enterLoadingFn("init");
        callFn("init");
    }}>
        Init
    </Button>);

    buttons.push(<Button type="primary" loading={loadings["update_sensors"]} onClick={() => {
        enterLoadingFn("update_sensors");
        callFn("update_sensors");
    }}>
        Update Sensors
    </Button>);

    buttons.push(<Button type="primary" loading={loadings["stage_to_rack"]} onClick={() => {
        enterLoadingFn("stage_to_rack");
        callFn("stage_to_rack");
    }}>
        Stage To Rack
    </Button>);

    buttons.push(<Button type="primary" loading={loadings["user_interaction_start"]} onClick={() => {
        enterLoadingFn("user_interaction_start");
        callFn("user_interaction_start");
    }}>
        Start Interacting
    </Button>);
    return buttons;
}

export class C240ControlPanelView extends Component {

    constructor(props) {
        super(props);
        this.deviceId = this.props.match.params.id;


        // from scanner.js
        this.usbConnectionCodeDict = {
            DISCONNECTED : "DISCONNECTED",
            CONNECTED : "CONNECTED",
            INITIALISED : "INITIALISED", 
            ERRORED : "ERRORED", 
            DOES_NOT_EXIST: "DOES_NOT_EXIST",
            UNKNOWN: "UNKNOWN"
        }

        this.state = {
            server_up: true,
            data: null,
            last_res: null,
            loadings: {},
            queue_state: {ongoing: null, queue: []},
            scanner_state: {},
            selectedCassette: "R0T0", // null or string key like "R0T11"
            usingDefaultSelectedCassette: true,
            modal_visible: false,
            is_superuser: false,
            gate_is_open: false,
            change_scan_region: false,  // used to hide/show rack view
            barcodeCacheBustingKey: (new Date()).getTime(),
            finalizingSlideSettings: false, // becomes true on clicking "Finalize slide setting" btn, false after http call
            shuttingDown: false,
            highlightSlideKey: -1,
            highlight: false,
            show_removed_tasks: false, // when true shows which scan/previews were removed
            remove_queue_interaction: false, //used to disable all queue buttons when needed
            restoreFailureMessageDisplayed: false,
            searchText: ""
        }
    }

    handleSearchChange = (e) => {
        this.setState({ searchText: e.target.value });
    }

    goToFirstNonEmptySlot = () => {

        if (!this.state.usingDefaultSelectedCassette) {
            return;
        }
        let rack = ((this.props.c240DeviceStatus.data || {}).rack_module || {}).RACK;

        if (rack) {
            for (let i=0; i<rack.length; i++) {
                for (let j = 0; j < rack[i].length; j++) {
                    if (rack[i][j].cassette_state._name_ !== "EMPTY") {
                        this.setState({selectedCassette: `R${i}T${j}`});
                        return;
                    }
                }
            }
        }
    }

    // used as callback method when user clicks on "Finalize slide setting" btn
    onFinalizeSlideSettingsClick = () => {
        this.setState({ finalizingSlideSettings: true });
    }

    // used as callback method when "Finalize slide setting" finishes or fails
    onFinalizedSlideSettings = () => {
        this.setState({ finalizingSlideSettings: false });
    }

    disableQueueInteraction = (val) => {
        this.setState({
            remove_queue_interaction: val,
        })
    }
    
    // used as a callback method when user changes scan region
    onStartChangeScanRegion = () => {
        // user is selecting scan region
        this.setState({ change_scan_region: true });
    }

    // used as a callback method when user finalizes scan region
    onFinalizeScanRegion = () => {
        // user finalized scan region
        this.setState({ change_scan_region: false });
    }

    updateQueue = (queueData) => {
        this.props.dispatch(updateQueueState(queueData));
    }

    enterLoading = (index) => {
        this.props.dispatch(updateLoaderState(true))
        this.setState(({ loadings }) => {
            const newLoadings = { ...loadings };
            newLoadings[index] = true;

            return {
                loadings: newLoadings,
            };
        });
    };

    removeLoading = (index) => {
        this.props.dispatch(updateLoaderState(false))
        this.setState(({ loadings }) => {
            const newLoadings = { ...loadings };
            newLoadings[index] = false;

            return {
                loadings: newLoadings,
            };
        });
    };

    callWithScanningProfile = (endpoint, options="", callback=null, show_info=true) => {
        // callback is called on 200 response code with response.data as argument
        let url = `/server/pre_process_scano/1/api~hts~` + endpoint + "/" + options;
        get_response(url)
            .then(response => {
                if (response.status !== 200) {
                    message.error("Error");
                    this.setState({
                        last_res: "Errored " + response.status
                    })
                    if(endpoint === "user_interaction_end"){//TODO:Fix This
                        this.onUserInteractionEnd()
                    }
                } else {
                    console.debug(response.data);
                    if(response.data.includes("Rack Camera Failure")){
                        message.error(`Cassette Detection Failure: Previous data has been reset. You can proceed using the scanner`, 15);
                    }

                    this.setState({
                        last_res: response.data.code + " " + response.data.message
                    })
                    if (show_info) {                        
                        message.info(response.data);
                    } else {
                        console.log(response.data.code + " " + response.data.message);
                    }
                    if (callback !== null) {
                        callback(response.data);
                    }
                }
                this.removeLoading(endpoint);
            })
            .catch(err => {
                console.error(err);
                this.removeLoading(endpoint);
            })
    };

    call = (endpoint, options="", callback=null, show_info=true) => {
        // callback is called on 200 response code with response.data as argument
        let url = `/server/scano/1/api~hts~` + endpoint + "/" + options;
        get_response(url)
            .then(response => {
                if (response.status !== 200) {
                    message.error("Error");
                    this.setState({
                        last_res: "Errored " + response.status
                    })
                } else {
                    console.debug(response.data);
                    if(response.data.includes("Rack Camera Failure")){
                        message.error(`Cassette Detection Failure: Previous data has been reset. You can proceed using the scanner`, 15);
                    }

                    this.setState({
                        last_res: response.data.code + " " + response.data.message
                    })
                    if (show_info) {                        
                        message.info(response.data);
                    } else {
                        console.log(response.data.code + " " + response.data.message);
                    }
                    if (callback !== null) {
                        callback(response.data);
                    }
                }
                this.removeLoading(endpoint);
            })
            .catch(err => {
                console.error(err);
                this.removeLoading(endpoint);
            })
    };

    componentDidMount = () => {
        this.props.dispatch(getC240Status());
        this.props.dispatch(getScannerState());
        this.poller = sagaMiddleware.run(watchPollStatus, this.props.dispatch, this.props.match.params.id);
        this.poller2 = sagaMiddleware.run(watchC240DeviceStatus, this.props.dispatch, this.goToFirstNonEmptySlot);
        this.poller3 = sagaMiddleware.run(watchC240ScannerStateUpdate, this.props.dispatch);
        this.poller4 = sagaMiddleware.run(watchPersistedStateStatus, this.props.dispatch);
        this.props.dispatch(updateEditorState(false));

        this.drawerCollapseStatus = this.props.drawerCollapsed;
        if (this.drawerCollapseStatus === false) {
            this.props.dispatch(closeDrawer());
        }
    }

    componentWillUnmount = () => {
        this.poller.cancel();
        this.poller2.cancel();
        this.poller3.cancel();
        this.poller4.cancel();
        if (this.drawerCollapseStatus === false) {
            this.props.dispatch(openDrawer());
        }
    }

    componentDidUpdate = () => {
        if(this.state.remove_queue_interaction){
            this.scrollToEndQueue();
        }

        this.checkDeviceStatus();
    }

    handleScannerShutdown = () => {
        stopScannerServer(this.deviceId,
            () => this.setState({ shuttingDown: true }),
            () => this.setState({ shuttingDown: false }),
            () => this.setState({ shuttingDown: false })
        );
    }

    itemToString = (obj) => {
        const {rack, tray, slide} = obj;
        return `R${rack}T${tray}S${slide}`;
    }

    onUserInteractionEnd = () => {
        this.props.dispatch(getDeviceStatus(this.deviceId));
        console.debug("Queue all scans now");
        // let tasks=["Removed tasks are : "]
        // if((((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).removedFromScanPreviewQueue.length!=0){
            
        //     for (const elem of (((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).removedFromScanPreviewQueue) {
        //         console.log("Removed these tasks: elem",elem)
        //         const {rack, tray, slide} = elem;
        //         const taskType = elem['taskType'];
        //         let key = `R${rack}T${tray}S${slide}`
        //         console.log("Removed these tasks: key",key)
        //         console.log("Removed these tasks: title",`${this.queueTitle(taskType)}R${rack}T${tray}S${slide}`)
        //         tasks.push(` ${this.queueTitle(taskType)}R${rack}T${tray}S${slide},`)
        //     }

        // this.removedTasks(tasks)
        // }
        // console.log("Removed these tasks: ",(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).removedFromScanPreviewQueue)        
        this.props.dispatch(getC240Status(this.onStatusUpdateAfterUserInteractionEnd));
        this.setState({
            show_removed_tasks: true
        });
    }

    onStatusUpdateAfterUserInteractionEnd = () => {
        const racks = (this.props.deviceStatus.data || {}).rack_module.RACK;

        let orderedItemsToQueue = [];

        for (let i = 0; i < racks.length; i++) {
            for (let j = racks[i].length - 1; j >= 0; j--) {
                if (racks[i][j].barcode_taken) {
                    for (let slide = 0; slide < 6; slide++) {
                        orderedItemsToQueue.push({rack: i, tray: j, slide: slide});
                        // removed endpoint for this
                        // this.queueItem(i, j, slide);
                    }
                }
            }
        }
        // removed from backend
        // this.queueMultipleItems(orderedItemsToQueue);
        // this.enterLoading("queue_state");
        console.debug("onStatusUpdateAfterUserInteractionEnd: calling scanner_state");
        this.call("scanner_state", "", this.onGetQueueState, false);
    }

    onGetQueueState = (response) => {
        this.props.dispatch(updateQueueState(response.scanPreviewQueue));
    }

    // called when user clicks on a cassette from the small rack view
    onSelectCassette = (key, slide=-1) => {
        if(key!=="R-1T-1"){
            this.setState({
                selectedCassette: key,
                highlightSlideKey: slide,
                highlight: true,
                usingDefaultSelectedCassette: false
            });

            setTimeout(() => {
                this.setState({
                    highlight: false
                })
            }, 2000)
        }
    }

    checkDeviceStatus = () => {
        let scannerStatus = (((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {});
        let systemState = ((scannerStatus || {}).systemState || {});

        systemStateNotificationHandler(systemState);
    }

    onOpenGateAfterCurrentScan = () => {
        this.enterLoading("open_gate_after_ongoing");
        this.call("open_gate_after_ongoing", "", this.onOpenGateRequestSuccess, false);
    }
    onOpenGateRequestSuccess = () => {
        message.success("Open Gate after current task scheduled")
        console.debug("onOpenGateAfterCurrentScan callback is working");
    }

    // TODO: add confirmation.
    //       stops everything (even the current scan)
    onStopEverythingNowAndOpenGate = () => {
        this.enterLoading("user_interaction_start");
        this.call("stop_everything_now", "", this.onStopEverythingNowSuccess, false);
    }
    onStopEverythingNowSuccess = () => {
        this.removeLoading("user_interaction_start");
    }

    openGate = (in_parallel=false) => {
        const fCall = in_parallel ? "open_gate_pause_loader" : "user_interaction_start"
        this.enterLoading(fCall);
        let _this = this;
        const callback = () => {
            _this.props.dispatch(getDeviceStatus(_this.deviceId));
        }
        this.call(fCall, "", callback);
    }

    onCloseGateBtnClick = (takeAllBarcodes, takeAllPreviews, takeAllScans, in_parallel=false) => {
        const fCall = in_parallel ? "close_gate_resume_loader" : "user_interaction_end"
        this.enterLoading(fCall);
        const mockHalapi = (((((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).mockConfig || {}).mockHalapi);
        this.setState({
            barcodeCacheBustingKey: (new Date()).getTime()
        });
        let options = "?mock_halapi=" + mockHalapi.toString() + "&takeAllBarcodes=" + takeAllBarcodes 
                        + "&takeAllPreviews=" + takeAllPreviews + "&takeAllScans=" + takeAllScans + "&sendUserId=true";
        
        this.callWithScanningProfile(fCall, options, this.onUserInteractionEnd, false);
    }

    removedTaskConfirmation = () => {
        // this.setState({
        //     show_removed_tasks: false
        // });
        let _this = this;
        const callback = () => {
            console.debug("set show_removed_tasks to false");
            _this.setState({
                show_removed_tasks: false
            }); 
        }
        console.debug("calling endpoint to hide removed tasks");
        this.call("hide_removed_tasks", "", callback, false);
    }

    alterTaskOrder = (e, rack, tray, slide, taskType, cb, endPoint) => {
        this.call(endPoint,`?rack=${rack}&tray=${tray}&slide=${slide}&taskType=${taskType}`, cb, true)
    }

    showModal = () => {
        this.setState({modal_visible: true});
    };
    
    handleOk = () => {
        this.setState({modal_visible: false});
    };
    
    handleCancel = () => {
        this.setState({modal_visible: false});
    };

    stopAfterCurrentScan = () => {
        const _this = this;
        Modal.confirm({
          title: 'Open Gate After Current Scan',
          icon: null,
          content: [<Row>After the current scan or preview gets finished, scanning will pause and the gate will open.</Row>,<br></br>,<Row>Are you sure?</Row>],
          okText: 'Yes',
          cancelText: 'Cancel',
          onOk() {
            _this.onOpenGateAfterCurrentScan();
        },
        });
        
    }

    stopNow = () => {
        const _this = this;
        Modal.confirm({
          title: 'Stop everything now and open the gate',
          icon: null,
          content: [<Row>Ongoing scan will be stopped immediately and the gate will open.</Row>,<br></br>,<Row>Are you sure?</Row>],
          okText: 'Yes',
          cancelText: 'Cancel',
          onOk() {
            _this.onStopEverythingNowAndOpenGate();
        },
        });
        
    }

    openGateBtn = () => {
        const _this = this;
        Modal.confirm({
          title: 'Open Gate',
          icon: null,
          content: [<Row>This will open the gate, allowing insertion of cassettes.</Row>,<br></br>,<Row>Are you sure?</Row>],
          okText: 'Yes',
          cancelText: 'Cancel',
          onOk() {
            _this.openGate();
        },
        });
        
    }


    scrollToEndQueue = () => {
        let el = document.getElementById('highlight');
        if(el !== null) el.scrollIntoView({ block: "end"});
    }

    handleRepeatPreview = () => {
        const url = `/server/scano/1/api~hts~repeat_previews/`;
        get_response(url)
            .then(response => {
                message.info("Added Preview items to queue");
            })
            .catch(err => {
                message.error("Error occurred while repeating current queue", err);
            })
    }

    handleRepeatScans = () => {
        const url = `/server/scano/1/api~hts~repeat_scans/`;
        get_response(url)
            .then(response => {
                message.info("Added Scans items to queue");
            })
            .catch(err => {
                message.error("Error occurred while repeating current queue", err);
            })
    }

    testFeederInteraction = () => {
        const url = `/server/scano/1/api~hts~test_feeder_interaction/`;
        get_response(url)
            .then(response => {
                message.info("Added items to queue");
            })
            .catch(err => {
                message.error("Error occurred while adding elements", err);
            })
    }

    continueQueuedTasks = () => {
        const fCall = "continue_queued_tasks"
        this.enterLoading(fCall);
        let _this = this;
        const callback = () => {
            _this.props.dispatch(getDeviceStatus(_this.deviceId));
        }
        this.call(fCall, "", callback);
    }

    render() {
        let data = [];
        data.push(this.props.c240DeviceStatus.server_up ? <Text mark>{"Raspberry Server : ONLINE"}</Text> : "Raspberry Server : OFFLINE");
        data.push((this.props.c240DeviceStatus.data || {}).init_done ? <Text mark>{"Software Init : Done"}</Text> : "Software Init : Not Done");
        data.push((this.props.c240DeviceStatus.data || {}).homing_done ? <Text mark>{"Homing : Done"}</Text> : "Homing : Not Done");

        let _scannerResponse = (((this.props.deviceStatus ||{}).scanner_health ||{}).scanner_response || {});

        if (_scannerResponse.failedToRestoreScannerState && !this.state.restoreFailureMessageDisplayed) {
            message.warning("Failed to restore previous data.")
            this.setState({restoreFailureMessageDisplayed: true});
        }

        const rack_view = [];
        const slideLevelScanPreviewStatus = (_scannerResponse||{}).slideLevelScanPreviewStatus;
        if ((this.props.c240DeviceStatus.data || {}).rack_module) {
            rack_view.push(
                <RackView
                    key={"rack-view-0"}
                    racks = {(this.props.c240DeviceStatus.data || {}).rack_module.RACK}
                    onSelectCassette = {this.onSelectCassette}
                    selectedCassette = {this.state.selectedCassette}
                    is_superuser = {this.state.is_superuser}
                    loadings = {this.state.loadings}
                    enterLoading = {this.enterLoading}
                    call = {this.call}
                    slideLevelScanPreviewStatus = {slideLevelScanPreviewStatus}
                />
            );

            const feeder_cassette = (this.props.c240DeviceStatus.data || {}).rack_module.soft_cassette_on_feeder;
            const stage_cassette = (this.props.c240DeviceStatus.data || {}).rack_module.soft_cassette_on_stage;
            data.push(feeder_cassette === null ? "[Soft] On Feeder : Empty" : 
            "[Soft] On Feeder : Rack " + (feeder_cassette || {}).rack + " Tray " + (feeder_cassette || {}).tray);
            data.push(stage_cassette === null ? "[Soft] On Stage : Empty" : 
            "[Soft] On Stage : Rack " + (stage_cassette || {}).rack + " Tray " + (stage_cassette || {}).tray);
        }

        // it doesn't make sense to show rack when user is changing scan region
        const show_rack = !this.props.c240LoaderState.editor_mode;
        
        let queue = [];
        queue.push(
            <Col key={"q-col-0"}>
                <ScanPreviewQueueView
                    systemState={this.props.deviceStatus !== undefined ? checkSystemState({1: this.props.deviceStatus}) : false}
                    queue_state={this.props.c240DeviceStatus.queue_state}
                    onSelectCassette={this.onSelectCassette}
                    alterTaskOrder={this.alterTaskOrder}
                    updateQueue={this.updateQueue}
                    propsDispatch={this.props.dispatch}
                    disableQueueInteraction = {this.disableQueueInteraction}
                    remove_queue_interaction = {this.state.remove_queue_interaction}
                    waitingForUserToCalibratePreview = {(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).waitForUserToCompletePreviewCalibration}
                    slideLevelScanPreviewStatus = {slideLevelScanPreviewStatus}
                    searchText = {this.state.searchText}
                />
            </Col>);

        if ((this.props.c240DeviceStatus.data || {}).loader_module) {
            data.push((this.props.c240DeviceStatus.data || {}).loader_module.cassette_detected === true ? "[S] Detected : Cassette" : "[S] Detected : Empty");
            data.push((this.props.c240DeviceStatus.data || {}).loader_module.cassette_on_feeder === true ? "[S] Feeder : Cassette" : "[S] Feeder : Empty");
            data.push((this.props.c240DeviceStatus.data || {}).loader_module.y_on_stage === true ? "[S] Y On Stage : True" : "[S]  Y On Stage : False");
            data.push((this.props.c240DeviceStatus.data || {}).loader_module.y_under_stage === true ? "[S]  Y Under Stage : True" : "[S]  Y Under Stage : False");

            const loader_arm_pos = ((this.props.c240DeviceStatus.data || {}).loader_module.loader_position || {}).loader_arm_pos;
            data.push("Loader Arm Pos : ("  + loader_arm_pos.x + "," + loader_arm_pos.y + "," + loader_arm_pos.z + ")");

            const encoder_pos = ((this.props.c240DeviceStatus.data || {}).loader_module.loader_position || {}).encoder_pos;
            data.push("Encoder Pos : ("  + encoder_pos.x + "," + encoder_pos.y + "," + encoder_pos.z + ")");

            data.push("[S] Detector Val : " + (this.props.c240DeviceStatus.data || {}).loader_module.cassette_detected_sensor);
            data.push("[S] Feeder Val : " + (this.props.c240DeviceStatus.data || {}).loader_module.cassette_on_feeder_sensor);
        }

        let buttons = getDebugButtonList(this.state.loadings, this.enterLoading, this.call);


        let htsState = ((_scannerResponse ||{}).htsStatus||{}).htsState;

        //previous loaders retained, needs refactoring at a later stage
        let showLoader = this.props.c240LoaderState?.show_loader || this.state.finalizingSlideSettings || this.state.shuttingDown
        
        let blockUI = showLoader;

        // take back to scanner page if something disconnects in b/w
        let allUsbDevicesConnected = true;

        let usbDependenciesStatus = _scannerResponse.usbDependenciesStatus;
        let httpDependenciesStatus =  _scannerResponse.httpDependenciesStatus;

        if (usbDependenciesStatus !== undefined && httpDependenciesStatus !== undefined) {
            for (let key in usbDependenciesStatus) {
                if (usbDependenciesStatus[key] !== this.usbConnectionCodeDict.INITIALISED && 
                    usbDependenciesStatus[key] !== this.usbConnectionCodeDict.CONNECTED && key !== 'upsStatus'
                    && key !== 'previewStatus') {
                    allUsbDevicesConnected = false;
                }
                if (key === 'previewStatus' 
                    && ((usbDependenciesStatus['previewStatus'] !== this.usbConnectionCodeDict.INITIALISED
                         && usbDependenciesStatus['previewStatus'] !== this.usbConnectionCodeDict.CONNECTED)
                       && (httpDependenciesStatus['piCameraStatus'] !== this.usbConnectionCodeDict.INITIALISED
                         && httpDependenciesStatus['piCameraStatus'] !== this.usbConnectionCodeDict.CONNECTED)) ) {
                    allUsbDevicesConnected = false;
                }
            }
            // TODO: add ups support in future if we restore mandatory check for it
        }

        let promptVisible = ((_scannerResponse.gateOpen ||
            _scannerResponse.waitForUserToStartQueueExecution) ||
            (this.state.show_removed_tasks && !_scannerResponse.gateOpen &&
                (_scannerResponse.removedFromScanPreviewQueue || {}).length!==0) ||
            (_scannerResponse.restoringScannerState));

        let restartingRPI = (((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).restartingRPIForIOError
        if (htsState === HTSState.STAGE_CLEANING) {
            promptVisible = false;
        }

        let blurClassName = promptVisible ? "blur":"";

        let spinningTipMessage = "loading";
        if (this.state.loadings["user_interaction_start"] || htsState === HTSState.OPENING_GATE) {
            blockUI = true;
            spinningTipMessage = "Opening the Gate";
        } else if (this.state.finalizingSlideSettings) {
            blockUI = true;
            spinningTipMessage = "Finalzing Slide Settings";
        } else if (this.state.shuttingDown) {
            blockUI = true;
            spinningTipMessage = "Shutting Down Scanner";
        } else if (htsState === HTSState.STAGE_CLEANING) {
            blockUI = true;
            spinningTipMessage = "Stage Cleaning is in progress, please finish it before using scanner."
        }

        if ((((this.props.deviceStatus || {}).scanner_health || {}).server_up === false) || restartingRPI) {
            return <Redirect to={"/scanners/" + this.deviceId + "/"}></Redirect>
        } else if ((((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).initialized === undefined) {
            return null;
        } else if (!allUsbDevicesConnected) {
            return <Redirect to={"/scanners/" + this.deviceId + "/"}></Redirect>
        } else {
            return (
                <ReloadConfigPromptWrapper deviceId={this.props.match.params.id}>
                    <div className="scanner-view full-parent">
                        <div style={{height: "60px"}}>
                        <C240Header
                            deviceId={this.deviceId}
                            blockUI={blockUI}
                            silentCalibration={(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).restartingRPISilent}
                            blurClassName={blurClassName}
                            queueState={this.props.c240DeviceStatus.queue_state}
                            openGateBtn={this.openGateBtn}
                            openGate={this.openGate}
                            closeGate={this.onCloseGateBtnClick}
                            gateOpen={(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).gateOpen}
                            htsState={htsState}
                            openGateScheduled={(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).openGateScheduled}
                            stopNow={this.stopNow}
                            stopAfterCurrentScan={this.stopAfterCurrentScan}
                            handleScannerShutdown={this.handleScannerShutdown}
                        />
                        </div>
                        {(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).initialized === true ? null : <Redirect to={"/scanners/"+this.deviceId+"/"}></Redirect>}

                        <div className="scanner-body full-width" style={{height: "calc(100% - 60px)"}}>
                        <Spin wrapperClassName={'full-parent'}
                            spinning={blockUI ? !promptVisible : null}
                            tip={spinningTipMessage}>
                        <Row className={blurClassName + ' full-parent'} style={{align:"bottom"}}>
                            {show_rack ?
                                    <Col key={"rack-view"} span={7} className="centered rack-small-view" style={{fontSize: "10px", paddingLeft:"40px", paddingRight: '10px'}}>
                                        {rack_view}
                                    </Col>
                                    : null
                            }
                            <Col key={"cassette-view"} span={ show_rack ? 10 : 19 } className={"full-height"}>
                                <Row className={"full-parent"} key={"cassette-view-row"}>{
                                    <C240CassetteView
                                        deviceId={this.deviceId}
                                        onFinalizeSlideSettingsClick={this.onFinalizeSlideSettingsClick}
                                        onFinalizedSlideSettings={this.onFinalizedSlideSettings}
                                        barcodeCacheBustingKey={this.props.barcodeCacheBustingKey}
                                        selectedCassette={this.state.selectedCassette}
                                        highlightSlideKey={this.state.highlightSlideKey}
                                        highlight={this.state.highlight}
                                        blockUI={blockUI}
                                    />
                                }</Row>
                            </Col>
                            <Col key={"scan-preview-q"} span={7} >
                                <div style={{height:'90vh', display: 'flex', flexDirection: 'column', marginTop: '7px', width: '100%', background: "#ffffff"}}>
                                    <div style={{position: 'sticky'}}>
                                    <Row
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        margin: '10px auto',
                                        gap: '10px'         // space between Q and the input
                                      }}
                                    >
                                      <div style={{ fontSize: '30px' }}>Q</div>
                                      <input
                                        type="text"
                                        placeholder="Search by slide name…"
                                        value={this.state.searchText}
                                        onChange={this.handleSearchChange}
                                        style={{
                                          margin: 0,       // remove bottom margin so it sits flush
                                          padding: '0.5rem',
                                          flex: 1,         // take up remaining space
                                          boxSizing: 'border-box',
                                          boxShadow:        'none',
                                          border: '1.9px solid rgba(107,105,105,0.65)',
                                          borderRadius:     '8px',
                                        }}
                                      />
                                    </Row>
                                    {cookie.loadAll().superuser === 'true' ?
                                    <Row style={{display: "flex", justifyContent: "space-between", marginBottom: "10px"}}>
                                        <Radio checked={_scannerResponse?.repeatPreview} onClick={this.handleRepeatPreview}> Repeat Previews </Radio>
                                        <Radio checked={_scannerResponse?.repeatScan} onClick={this.handleRepeatScans}> Repeat Scans </Radio>
                                    </Row>
                                        : null}
                                    </div>
                                    <div style={{ overflowY: 'auto', flex: 1 }}>{queue}</div>    
                                </div>
                            </Col>
                        </Row>
                        {this.state.is_superuser?<Row>
                            <Col span={3}>
                                <List
                                grid={{ gutter: 5, column: 1}}
                                size="small"
                                header={<div>Action Buttons</div>}
                                bordered
                                dataSource={buttons}
                                renderItem={item => <List.Item>{item}</List.Item>}
                                />
                            </Col>
                            <Col span={4} offset={1}>
                                <List
                                grid={{ gutter: 5, column: 1 }}
                                size="small"
                                header={<div>State Variables</div>}
                                bordered
                                dataSource={data}
                                style={{backgroundColor: this.props.c240DeviceStatus.server_up ? '#B4F6CE' : '#F5B9A9'}}
                                renderItem={item => <List.Item>{item}</List.Item>}
                            />
                            {"Last Response : " + this.state.last_res}
                            </Col>
                        </Row>:null}
                        </Spin>
                        </div>

                        { promptVisible ?
                                <GatePrompt
                                handleProgressChange={this.props.handleProgressChange}
                                loadings = {this.state.loadings}
                                deviceId={this.props.deviceId}
                                currentProcessIndex={this.props.currentProcessIndex}
                                cassetteSize={this.state.cassetteSize}
                                blockUI = {blockUI}
                                prompt = { _scannerResponse.gateOpen ?
                                            C240PromptType.CLOSE_GATE_PROMPT
                                            : (_scannerResponse.waitForUserToStartQueueExecution) && !(_scannerResponse.gateOpen) ?
                                                C240PromptType.OPEN_GATE_PROMPT
                                                : this.state.show_removed_tasks?
                                                    C240PromptType.REMOVED_TASKS_PROMPT
                                                    : (_scannerResponse.restoringScannerState) ?
                                                        C240PromptType.OPEN_GATE_PROMPT
                                                        : null }
                                closeGate = {(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).gateOpen ? this.onCloseGateBtnClick : null}
                                continueQueuedScans = {this.continueQueuedTasks}
                                removedTaskConfirmation = {this.state.show_removed_tasks && !(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).gateOpen && (((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).removedFromScanPreviewQueue.length!==0 ? this.removedTaskConfirmation : null}
                                removedtasks = {this.state.show_removed_tasks && !(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).gateOpen && (((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).removedFromScanPreviewQueue.length!==0 ? (((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).removedFromScanPreviewQueue : null}
                                preventLoaderMovement = {(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).preventLoaderMovement}
                                invalidCassettesLoaded = {(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).invalidCassettesLoaded}
                                cassetteOnStage = {((this.props.c240DeviceStatus.data || {}).rack_module || {}).soft_cassette_on_stage}
                            />

                            : null
                        }
                    </div>
                </ReloadConfigPromptWrapper>
            )
        }
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        adminState: state.adminUrlReducer,
        c240LoaderState: state.c240LoaderReducer,
        deviceStatus: state.deviceStatusReducer[ownProps.match.params.id],
        drawerCollapsed: state.dashboardReducer.drawerCollapsed,
        c240DeviceStatus: state.c240DeviceStatusReducer
    };
};

export default connect(mapStateToProps)(C240ControlPanelView);
